import loadable from '@loadable/component';

export const InvoicesListContainerLoadable = loadable(
  () => import('./InvoicesListContainer'),
  { resolveComponent: (module) => module.InvoicesListContainer },
);
